import {
  AxiosPost,
  AxiosPut,
  AxiosDelete,
} from "../../helpers/microserviceAPIs"

import { tasksUrl } from "../../config/microservicesUrls"
const api_url = tasksUrl()

export async function taskApiGetCreatedTasksPOST(jwt, requestBody) {
  return await AxiosPost(jwt, `${api_url}/Tasks/Get/Created`, requestBody)
}

export async function taskApiGetAssignedTasksPOST(jwt, requestBody) {
  return await AxiosPost(jwt, `${api_url}/Tasks/Get/Assigned`, requestBody)
}

export async function taskApiGetAssignedTasksFromDatePOST(jwt, requestBody) {
  return await AxiosPost(
    jwt,
    `${api_url}/Tasks/Get/AssignedFromDate`,
    requestBody
  )
}

export async function taskApiUpdateTaskPUT(jwt, task) {
  const res = await AxiosPut(jwt, `${api_url}/Tasks/Update`, task)
  if (res === null) {
    throw new Error(`Unable to update task (Id: ${task.id})`)
  }
  return res
}

export async function taskApiCreateTasksPOST(jwt, task) {
  const res = await AxiosPost(jwt, `${api_url}/Tasks/CreateMultiple`, task)
  if (res === undefined) {
    throw new Error(`Unable to create task`)
  }
  return res
}

export async function taskApiDELETE(jwt, taskId) {
  const res = await AxiosDelete(jwt, `${api_url}/Tasks/Delete/${taskId}`)
  if (res === null) {
    throw new Error(`Unable to delete task (Id: ${taskId})`)
  }
  return true
}

export async function TaskApiMarkCompletePUT(jwt, taskId) {
  const res = await AxiosPut(jwt, `${api_url}/Tasks/MarkComplete/${taskId}`)
  if (res === null) {
    throw new Error(`Unable to mark task as complete (Id: ${taskId})`)
  }
  return true
}
